/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestMaxFileSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_MAX_FILE_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestMaxFileSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestMaxFileSizeSettingParser.decode(input).map(res => new NewAutoTestMaxFileSizeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestMaxFileSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestMaxFileSizeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestMaxFileSizeSettingParser.schema();
    }
}
